function initHeroRotatingWords()
{
    var containers = document.querySelectorAll(".we-hero-rotating");

    for (var c = 0; c < containers.length; c++)
    {
        var words = containers[c].querySelectorAll(".we-hero-word");

        if (words.length > 1)
        {
            var speed = parseInt(containers[c].getAttribute("data-speed"), 10) || 2000;
            var idx = 0;

            setInterval(function heroRotateWord()
            {
                words[idx].classList.remove("active");
                idx = (idx + 1) % words.length;
                words[idx].classList.add("active");
            }, speed);
        }
    }
}

document.addEventListener("DOMContentLoaded", initHeroRotatingWords);
